import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

import { Button, tokens } from '@hotjar/hotsauce';

const ButtonsBox = styled.div`
  display: flex;
`;

const CreateZap = styled(Button)`
  margin-right: ${tokens.spacer.x1};
`;

export const CREATE_ZAP_URL = 'https://zapier.com/app/editor';

export const MANAGE_ZAPS_URL = 'https://zapier.com/app/zaps';

export const ZapierActions = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <ButtonsBox>
      <CreateZap
        icon="open_new_window"
        as="a"
        isExternal
        href={CREATE_ZAP_URL}
        rel="noopener noreferrer"
      >
        {t('integrations:zapier.create')}
      </CreateZap>
      <Button
        kind="ghost"
        icon="open_new_window"
        as="a"
        isExternal
        href={MANAGE_ZAPS_URL}
        rel="noopener noreferrer"
      >
        {t('integrations:zapier.manage')}
      </Button>
    </ButtonsBox>
  );
};
